import React from "react";
import { withStyles } from '@material-ui/core/styles';
import $ from 'jquery';
import {useEffect,useRef, useState} from "react";
import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';

import hashtag from '../media/instruction/hashtag.gif';
import vote from '../media/instruction/vote.gif';
import updown from '../media/instruction/updown.gif';
import hashtagExample from '../media/instruction/hashtag-example.png';
import flag from '../media/instruction/flag.png';
import reason from '../media/instruction/flag-reason.png';
import ButtonGroup from '@material-ui/core/ButtonGroup';
const useStyles = makeStyles ((theme) => ({
      root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        padding:0
      }
      ,img:{
        maxWidth: '80%'
      },
      li:{
        paddingBottom: '10px'
      }  
}));


export default function Posts() {
  const classes=useStyles();
  const [posts, setPosts] = useState([])
  const [open, setOpen] = React.useState(false);
  const [numInstPage, setInstNumPage]=useState(0);

  const instructionOpen = () => {
    setOpen(true);
  };

  const instructionClose = () => {
    setOpen(false);
  };

  useEffect(()=>{
    $.ajax({
      url:'../api/get-posts/',
      method: 'GET',
      data: {},
      success: function(res){
        setPosts(res.posts)
      },  
  })
  })

  const goto=(post_no)=>{
      window.location.href='/post/'+String(post_no)+'/';
    }
  return (
          <div>
            <div>
              
            <Typography variant="h5">
              User-Generated Labels
            </Typography>
            <Typography>
              You can experience the concept of user-generated labels (UGLs) in this demo. With UGLs, you can express your reaction to each comment by making a short text label or voting on others' labels. Please visit our project website for more information on this project. <a href="https://reaction.kixlab.org/" target="_blank">https://reaction.kixlab.org/ </a></Typography>

            </div>
        <div style={{textAlign:'right', marginBottom: '15px'}}>
        <Button variant='outlined' style={{backgroundColor: 'orange', border: 'none'}} onClick={instructionOpen} >How can I use UGLs?</Button>
        <Modal
          open={open}
          onClose={instructionClose}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <div style={{margin:'auto', marginTop: '100px', width: '800px',padding: '20px', backgroundColor: 'white', paddingBottom: '100px', border:'1px solid lightblue'}}>
              <div style={{textAlign:'right'}}>
                  <Button variant='outlined' size='small' style={{padding: '0'}}color='secondary' onClick={instructionClose} >X</Button>
                </div>
            <Typography variant='h5' className={classes.li}>
              How To Use 
              </Typography>
              {numInstPage===0? 
                <div style={{textAlign:'justify', marginBottom: '20px'}}>
                  <Typography variant='body1'>Below we explain how to use this system. Please read below instruction thorougyly.</Typography>
                  <Typography variant='body1' component={'ul'}>
                    <li className={classes.li}>
                    In this task, you are going to read a post and comments from an online discussion forum.
                    </li>
                    <li className={classes.li}>
                    As in common discussion platform, you can write a comment to the post or reply to others' comments, or vote or react to others' comments.
                    </li >
                    <li className={classes.li}> However, in this task, the way of 'voting' or 'reaction' is a bit different. You are going to vote or react to each comment through <span style={{color: "blue"}}>text</span> buttons. </li>
                    <img className={classes.img} id='img-hashtag-example' alt='gif on how to add hashtag buttons' src={hashtagExample} style={{border:'1px solid lightgrey'}}/>
                  </Typography>
                  </div> : null}
              {numInstPage===1? 
                <div style={{textAlign:'justify', marginBottom: '20px'}}>
                <Typography variant='body1' component={'ul'}>
                  <li>You can <span style={{color: 'blue'}}> create text buttons </span>that describe what you like (upvote) or dislike (downvote) about the comments.
                    <ul>
                      <li>
                        The text should contain more than 2 characters and cannot exceed 20 characters. 
                      </li>
                      <li>
                        The text cannot include white space.
                      </li>
                      <li>
                        You can generate multiple text buttons on each comment. 
                      </li>
                      <img className={classes.img} id='img-hashtag' alt='gif on how to add hashtag buttons' src={hashtag} />
                      </ul>
                      </li>
                    <li>
                      Or you can <span style={{color: 'blue'}}> click text buttons </span> generated by others to express your opinion. 
                      <ul>
                      <li>
                        You can vote on multiple buttons on each comment.
                      </li>
                      <img className={classes.img} id='img-vote' alt='gif on how to vote on hashtag buttons' src={vote} />
                      </ul>
                    </li>
                </Typography>
              </div> : null}
              {numInstPage===2? 
                <div style={{textAlign:'justify', marginBottom: '20px'}}>
                <Typography variant='body1' component={'ul'}>
                  <li>Please  <span style={{color: 'blue'}}>DO</span>
                    <ul>
                      <li>
                        Use unit of word or short phrases as text label to specify what you like/dislike about the comment. 
                      </li>
                      <li>
                        Use labels that evaluate certain aspects of the comments. <span style={{color: 'blue'}}> Logical, TooEmotional, StrongArgument, Misinformation </span> are good examples.
                      </li>
                    </ul>
                  </li>
                  <li>Please <span style={{color: 'red'}}>DON'T</span>
                    <ul>
                      <li>
                        Do not use bad words. Text button or comments with bad words can be removed  can be removed by researchers without any pre/post notificaiton.
                      </li>
                      <li>
                        Do not make long sentences as a text button. Long sentences should be left in a form of comment or reply. 
                      </li>
                    </ul>
                  </li>
                </Typography>
              </div> : null}
              {numInstPage===3? 
                <div style={{textAlign:'justify', marginBottom: '20px'}}>
                <Typography variant='body1' component={'ul'}>
                  <li>Please  <span style={{color: 'blue'}}>DO</span>
                    <ul>
                      <li>
                      You can flag a hashtag if it is insulting or irrelevant. To flag, right-click the hahstag and click 'FLAG THIS BUTTON' and submit it with a reason.                     
                      </li>
                      <div style={{textAlign:'center'}}>
                      <img style={{width:'200px'}} id='img-vote' alt='gif on how to vote on hashtag buttons' src={flag} />
                      <img style={{width:'200px'}} id='img-vote' alt='gif on how to vote on hashtag buttons' src={reason} />
                      </div>
                    </ul>
                  </li>
                </Typography>
              </div> : null}
              <div style={{textAlign: 'center'}}>
              <ButtonGroup color="primary" variant="contained" aria-label="outlined primary button group">
                <Button onClick={()=>setInstNumPage(numInstPage-1)} disabled={numInstPage===0}>Prev</Button>
                <Button onClick={()=>setInstNumPage(numInstPage+1)} disabled={numInstPage===3}>Next</Button>
              </ButtonGroup>
              </div>
          </div> 
        </Modal>
        </div>
        <Typography variant="h6">Discussion Topics</Typography>
        <Typography>Click on each topic below to join the discussion. </Typography>
        <List  className={classes.root}>
            <Divider />
            {posts.map((post, idx)=>{
              return (
                <div key={post.post_no}>
                  <ListItem button onClick={()=>goto(post.post_no)}>
                    <ListItemText primary={post.title} />
                  </ListItem>
                  <Divider />
                </div>
              )
            })}
        </List>
        </div>
          );
}